import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Mail } from 'react-feather'; // Feather icons
import { trackEvent } from './utils/amplitude'; // Import the trackEvent function
import { getCurrencySymbol } from './utils/currency';
import Footer from './Footer';


function LandingPage() {
    const navigate = useNavigate();
    const currency = getCurrencySymbol();

    useEffect(() => {
        // Track page view
        trackEvent('page_viewed', { pageName: 'LandingPage' });
        
        const urlParams = new URLSearchParams(window.location.search);
        const token = urlParams.get('token');
        const inviteToken = urlParams.get('invite');
        
        console.log('Extracted Token:', token); // Debug log
        console.log('Extracted Invite Token:', inviteToken); // Debug log
        
        if (token) {
            localStorage.setItem('token', token); // Save the token in localStorage
            console.log('Token stored in localStorage:', localStorage.getItem('token')); // Debug log
            
            // Clear the token from the URL to prevent redirect loops
            const newUrl = window.location.pathname;
            window.history.replaceState({}, document.title, newUrl);
            
            // Redirect to the workspace page
            navigate('/workspace');
        } else if (inviteToken) {
            // Store invite token for after login
            localStorage.setItem('pendingInviteToken', inviteToken);
            console.log('Invite token stored for after login:', inviteToken);
            
            // Show a brief message that invite was saved
            const messageDiv = document.createElement('div');
            messageDiv.style.cssText = `
                position: fixed;
                top: 20px;
                left: 50%;
                transform: translateX(-50%);
                background: #4CAF50;
                color: white;
                padding: 15px 25px;
                border-radius: 5px;
                z-index: 10000;
                font-size: 16px;
                box-shadow: 0 4px 6px rgba(0,0,0,0.1);
            `;
            messageDiv.textContent = '✅ Workspace invite saved! Please log in to join.';
            document.body.appendChild(messageDiv);
            
            // Remove message after 3 seconds
            setTimeout(() => {
                if (messageDiv.parentNode) {
                    messageDiv.parentNode.removeChild(messageDiv);
                }
            }, 3000);
            
            // Clear the invite token from the URL
            const newUrl = window.location.pathname;
            window.history.replaceState({}, document.title, newUrl);
        }
    }, [navigate]);

    const handleGoogleSignup = () => {
        console.log('Redirecting to Google Sign-In...');
        trackEvent('button_clicked', { buttonName: 'Google Signup' });
        
        // Determine backend URL based on environment
        const backendUrl = process.env.NODE_ENV === 'production' 
            ? 'https://proto-backend-d2c1638486b9.herokuapp.com'
            : 'https://proto-backend-d2c1638486b9.herokuapp.com';
            
        window.location.href = `${backendUrl}/auth/google`; // Backend Google auth route
    };

    // const handleNavigateToDark = () => {
    //     navigate('/d');
    // };

    const [waitlistEmail, setWaitlistEmail] = useState('');
    const [waitlistMessage, setWaitlistMessage] = useState('');
    const [openFAQ, setOpenFAQ] = useState(null);
    const [showDemoModal, setShowDemoModal] = useState(false);
    const [showWaitlistModal, setShowWaitlistModal] = useState(false);

    const handleRequestAccess = () => {
        setShowWaitlistModal(true);
        trackEvent('request_access_clicked');
    };

    const handleWaitlistSignup = async () => {
        if (!waitlistEmail) {
            setWaitlistMessage('Please enter a valid email.');
            return;
        }
    
        try {
            const response = await fetch('https://proto-backend-d2c1638486b9.herokuapp.com/join-waitlist', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email: waitlistEmail }),
            });
    
            if (response.ok) {
                trackEvent('waitlist_signup', { email: waitlistEmail });

                setWaitlistMessage('Thank you for joining the waitlist!');
                setWaitlistEmail(''); // Clear the input field
                
                // Close modal after a short delay to show success message
                setTimeout(() => {
                    setShowWaitlistModal(false);
                    setWaitlistMessage('');
                }, 2000);
            } else {
                setWaitlistMessage('Failed to join the waitlist. Please try again.');
            }
        } catch (error) {
            console.error('Error joining waitlist:', error);
            setWaitlistMessage('An error occurred. Please try again.');
        }
    };
   
    // Add this new useEffect for the animation of the Merra.ai to Memorable text // Masked because not used
    /*useEffect(() => {
        const interval = setInterval(() => {
            // Start fade out
            setIsTransitioning(true);
            
            // Change to "Memorable" after fade out
            setTimeout(() => {
                setDisplayTextFade("Memorable");
                setIsTransitioning(false);
            }, 500);

            // Start fade out for changing back
            setTimeout(() => {
                setIsTransitioning(true);
                
                // Change back to "Merra.ai" after fade out
                setTimeout(() => {
                    setDisplayTextFade("Merra.ai");
                    setIsTransitioning(false);
                }, 500);
            }, 3000);
        }, 8000);

        return () => clearInterval(interval);
    }, []);*/

    const [password, setPassword] = useState('');
    const [isAuthenticated, setIsAuthenticated] = useState(() => {
        return localStorage.getItem('isAuthenticated') === 'true';
    });
    const [errorMessage, setErrorMessage] = useState('');

    const handlePasswordSubmit = (e) => {
        e.preventDefault(); // This should prevent the form from submitting
        console.log('Password submitted:', password);
        
        if (password === 'B3T4') {
            console.log('Password correct, setting isAuthenticated to true');
            setIsAuthenticated(true);
            setErrorMessage('');
            
            // Store authentication in localStorage to persist across tabs
            localStorage.setItem('isAuthenticated', 'true');
        } else {
            console.log('Password incorrect');
            setErrorMessage('Incorrect password');
        }
    };

    const [showJumbo, setShowJumbo] = useState(true);
    const [jumboOpacity, setJumboOpacity] = useState(1);

    useEffect(() => {
        // Arrêter l'animation après 10 secondes
        const timer = setTimeout(() => {
            setShowJumbo(false);
        }, 10000); // 10000ms = 10 secondes

        return () => clearTimeout(timer);
        
    }, []);

    useEffect(() => {
        // Créer un intervalle qui diminue l'opacité toutes les 2 secondes
        const fadeInterval = setInterval(() => {
            setJumboOpacity(prevOpacity => {
                if (prevOpacity <= 0) {
                    clearInterval(fadeInterval); // Arrêter l'intervalle quand l'opacité atteint 0
                    return 0;
                }
                return prevOpacity - 0.2; // Diminuer l'opacité de 0.1
            });
        }, 1000); // Toutes les secondes

        // Nettoyer l'intervalle après 5 étapes (10 secondes total pour le fade)
        setTimeout(() => clearInterval(fadeInterval), 10000);

        return () => clearInterval(fadeInterval);
        
    }, []);

    useEffect(() => {
        const handleStorageChange = (e) => {
            if (e.key === 'isAuthenticated') {
                setIsAuthenticated(e.newValue === 'true');
            }
        };
        
        window.addEventListener('storage', handleStorageChange);
        return () => window.removeEventListener('storage', handleStorageChange);
    }, []);    

    return (
        <div style={{ textAlign: 'center' }}>

            <div style={{position:'absolute', /*top:'400vh'*/}}>
                <div class="relative flex flex-col h-[100vh] items-center justify-center transition-bg">
                    <div class="card card--4">

                        <div class={showJumbo ? "jumbo absolute -inset-[10px]" : "absolute -inset-[10px]"} style={{height:'100%', width:'100%', transition: 'all 4s ease-in-out', opacity: jumboOpacity,}}>
                            <div style={{height:'350px', width:'100px'}}/>
                        </div>

                        <h1 className="gradient-text" style={{position:'absolute', top:'100px', left:'0px', right:'0px', maxWidth:'100vw', fontWeight: 700}}>Merra.ai<br/><h3 style={{fontWeight: 700}}>Create unskippable content</h3></h1>
                        
                        <div style={{display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center'}}>
                            <p style={{width:'50vw', maxWidth:'450px', justifySelf:'center', color:'grey'}}>
                                Merra is for small companies with a ton of raw videos but no time to edit them.
                                <br/>
                                <br/>
                                Our AI doesn't generate artificial content, it edits yours in seconds.
                                <br/>
                                <br/>
                                <strong className="gradient-text" style={{fontSize:'18px'}}>The best of both worlds:</strong>
                                <br/>
                                <strong className="gradient-text" style={{fontSize:'18px'}}>YOUR content, at the speed of AI.</strong>
                                <br/>
                                <br/>
                                It's like having an AI team of content writers, video producer, editor and voice artist for voiceover content.
                                <br/>
                                <br/>
                                No need to prompt, trim, or move clips on a timeline. Just click 'regenerate' again and again until you're happy with the result.
                                <br/>
                                <br/>
                                <br/>
                                <br/>
                                <strong><span style={{color: 'black'}}>Sign up now, no credit card required</span></strong>
                            </p>
                        </div>

                        {!isAuthenticated ? (
                            <div style={{marginTop: '0px'}}>
                                <form onSubmit={handlePasswordSubmit}>
                                    <input
                                        type="password"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        placeholder="Enter password"
                                        style={{
                                            marginRight: '10px',
                                            borderRadius: '10px',
                                            border: '1px solid #ccc',
                                            backgroundColor: 'transparent',
                                            padding: '10px',
                                            fontSize: '15px',
                                            color: 'black',
                                            textAlign: 'center'
                                        }}
                                    />
                                    <br/>
                                    <button  type="submit" class='waitlist-button' style={{margin:'10px', borderWidth:'Opx', top:'-2px'}}>
                                        <span style={{color: 'black'}}>Submit</span>
                                        <span class="waitlist-shimmer"></span>
                                    </button>
                                </form>
                                {errorMessage && <p style={{color: 'red', marginTop: '10px'}}>{errorMessage}</p>}
                                <br/>
                                or
                                <br/>
                                <br/>
                                <strong style={{color: 'black'}}>Request access to the beta:</strong>
                                <br/>
                                <button onClick={handleRequestAccess} class='waitlist-button' style={{margin:'10px', borderWidth:'Opx', top:'-2px'}}>
                                    <span style={{color: 'black'}}>Request access</span>
                                    <span class="waitlist-shimmer"></span>
                                </button>
                            </div>
                        ) : (
                            <>
                                <p style={{color: 'black'}}>
                                    Use your google account to sign up:
                                </p>
                                <div style={{display:'flex', gap:'15px', alignItems:'center', justifyContent:'center', flexWrap:'wrap'}}>
                                    <button onClick={handleGoogleSignup} className='google-btn' style={{flexShrink:1, maxWidth:'100%'}}>
                                        <div className="google-icon"/>
                                        Continue with Google
                                    </button>
                                    <button 
                                        onClick={() => setShowDemoModal(true)}
                                        className='waitlist-button'
                                        style={{
                                            margin:'0',
                                            borderWidth:'0px',
                                            flexShrink:1,
                                            maxWidth:'100%'
                                        }}
                                    >
                                        <span style={{color: 'black'}}>▶ Watch Demo (2min)</span>
                                        <span className="waitlist-shimmer"></span>
                                    </button>
                                </div>
                                <div style={{display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center'}}>
                                    <p style={{wordBreak:'break-word'}}>
                                        <Link to="/confidentiality-rules" style={{ color: 'blue', textDecoration: 'underline' }}>
                                            View our Confidentiality Rules
                                        </Link>
                                    </p>
                                    <p style={{wordBreak:'break-word'}}>
                                        <Link to="/privacy-policy" style={{ color: 'blue', textDecoration: 'underline' }}>
                                            Privacy Policy
                                        </Link>
                                        {' | '}
                                        <Link to="/terms-of-service" style={{ color: 'blue', textDecoration: 'underline' }}>
                                            Terms of Service
                                        </Link>
                                    </p>
                                </div>
                            </>
                        )}
                        <br />
                        <div>
                            <img 
                                src={`/memoji13.png`} 
                                alt="Memoji" 
                                style={{ marginTop: '30px', width: '50px', height:'50px', borderRadius:'25px'}} 
                            />

                            <img 
                                src={`/memoji14.png`} 
                                alt="Memoji" 
                                style={{ marginTop: '30px', width: '50px', height:'50px', borderRadius:'25px', marginLeft:'10px'}} 
                            />

                            <img 
                                src={`/memoji10.png`} 
                                alt="Memoji" 
                                style={{ marginTop: '30px', width: '50px', height:'50px', borderRadius:'25px', marginLeft:'10px'}} 
                            />


                            <img 
                                src={`/memoji12.png`} 
                                alt="Memoji" 
                                style={{ marginTop: '30px', width: '50px', height:'50px', borderRadius:'25px', marginLeft:'10px'}} 
                            />
                            <img 
                                src={`/memoji9.png`} 
                                alt="Memoji"
                                style={{ marginTop: '30px', width: '50px', height:'50px', borderRadius:'25px', marginLeft:'10px'}} 
                            />
                            <img 
                                src={`/memoji8.png`} 
                                alt="Memoji" 
                                style={{ marginTop: '30px', width: '50px', height:'50px', borderRadius:'25px', marginLeft:'10px'}} 
                            />
                            <img 
                                src={`/memoji15.png`} 
                                alt="Memoji" 
                                style={{ marginTop: '30px', width: '50px', height:'50px', borderRadius:'25px', marginLeft:'10px'}} 
                            />
                            
                        </div>
                        <p style={{color: 'black'}}>
                            Made by Boukar Sall
                            <br/>
                            <Mail size={15} /> boukar . o . sall [at] gmail . com
                            <br/>
                            Any questions? Feel free to reach out
                        </p>
                        <a href="https://www.linkedin.com/in/boukar-sall" target="_blank" rel="noopener noreferrer">
                            <img 
                                src={`https://cdn-icons-png.flaticon.com/512/174/174857.png`} 
                                alt="linkedin" 
                                style={{ width: '15px', height:'15px', borderRadius:'2px', marginRight:'5px'}} 
                            />
                            linkedin.com/in/boukar-sall
                        </a>

                        <div style={{display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center'}}>
                            <div class="scroll" style={{marginTop:'30px', marginBottom:'50px'}}/>
                        </div>

                    </div>
                    <div style={{display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', backgroundColor:'#FCFCF8'}}>
                        
                        
                        {/* Example Video Section */}
                        <div style={{marginBottom:'40px', marginTop:'40px', color: 'black', textAlign: 'center', padding: '20px'}}>
                            <h2 className="gradient-text" style={{marginBottom:'20px', fontSize:'32px', fontWeight: 700}}>See Merra.ai in Action</h2>
                            <p style={{color: 'black', marginBottom:'30px', fontSize:'16px', maxWidth:'600px', margin:'0 auto 30px auto'}}>
                                This video was generated in few seconds with Merra.ai.
                                <br/>
                                Script, voiceover, editing, music, subtitles...
                            </p>
                            
                            <div style={{ position: 'relative', display: 'inline-block' }}>
                                <video
                                    src="https://proto-filesharing.s3.eu-north-1.amazonaws.com/public/Example-New-GenerateVideoWithVoiceover-Merra-2.mp4"
                                    controls
                                    style={{
                                        maxWidth: '600px',
                                        height: '300px',
                                        borderRadius: '12px',
                                        boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                                        marginBottom: '30px',
                                    }}
                                    playsInline
                                >
                                    <source src="https://proto-filesharing.s3.eu-north-1.amazonaws.com/public/Example-New-GenerateVideoWithVoiceover-Merra-2.mp4" type="video/mp4" />
                                    Your browser does not support the video tag.
                                </video>
                                <div
                                    style={{
                                        position: 'absolute',
                                        top: '10px',
                                        left: '15px',
                                        color: 'white',
                                        fontSize: '16px',
                                        fontWeight: 'bold',
                                        textShadow: '0 1px 3px rgba(0,0,0,0.8)',
                                        pointerEvents: 'none',
                                    }}
                                >
                                    Example
                                </div>
                            </div>
                        </div>

                        {/* Waitlist modal */}
                        {/* <div style={{marginBottom:'50px', marginTop:'100px'}}>
                            <span style={{fontWeight:'bold', color: 'black'}}>Join our waitlist to get access to the beta</span>
                            <div class="field-wrapper" style={{marginTop:'10px'}}>
                                <input value={waitlistEmail} onChange={(e) => setWaitlistEmail(e.target.value)} autoComplete="off" name="hidden" class="field" maxLength="256" placeholder="Your email" type="text" id="mail" required style={{fontSize:'15px', color: 'black', backgroundColor: '#FFFFFF50', borderRadius:'10px', padding:'0px 10px', border:'1px solid #ccc'}}>
                                </input>
                                <button onClick={handleWaitlistSignup} class='waitlist-button' style={{margin:'10px', marginTop:'25px', borderWidth:'Opx'}}>
                                    <span style={{color: 'black'}}>Join waitlist</span>
                                    <span class="waitlist-shimmer"></span>
                                </button>
                                {waitlistMessage && <p style={{ marginTop: '10px', color: 'green' }}>{waitlistMessage}</p>}
                            </div>
                        </div> */}
                        {/* Name explanation */}
                        {/* <div style={{ color: 'black', textAlign: 'center', marginTop: '0px', padding: '20px', marginBottom:'100px', paddingRight:'100px', paddingLeft:'100px', borderRadius: '8px', width:'50vw'}}>
                            <h2 style={{color: 'black'}}>Why "Merra"?</h2>
                            <p>
                                The name "Merra" is inspired by the word "mera," which carries profound and diverse meanings across cultures and languages. 
                                <br/>
                                <br/>
                                In Hindi, "mera" (मेरा) means "mine," evoking a sense of personal connection and ownership. 
                                <br/>
                                <br/>
                                In Portuguese and Spanish, it signifies something "pure," "authentic," or "genuine," reflecting clarity and simplicity. 
                                <br/>
                                <br/>
                                In Greek, "mera" (μέρα) means "day," symbolizing new beginnings and opportunities. 
                            </p>
                        </div> */}

                        {/* Mission */}
                        {/* <div style={{ color: 'black', textAlign: 'center', marginTop: '0px', padding: '20px', marginBottom:'100px', paddingRight:'100px', paddingLeft:'100px', borderRadius: '8px', width:'50vw'}}>
                            <h2 style={{color: 'black'}}>Our Purpose</h2>
                            <p>
                                Merra is on a mission to make cutting-edge AI available and adopted.
                                <br/>
                                <br/>
                                When most are focused on the technological aspect of AI, we find use-cases, then we build and market products for the most advanced AI technologies.
                                <br/>
                                <br/>
                            </p>
                        </div> */}

                        {/* Pricing Section */}
                        <div style={{ color: 'black', textAlign: 'center', marginTop: '0px', padding: '20px', marginBottom:'40px', borderRadius: '8px', width:'90vw', maxWidth:'1200px'}}>
                            <h2 className="gradient-text" style={{marginBottom:'20px', fontSize:'32px', fontWeight: 700}}>Pricing</h2>
                            <p style={{marginBottom:'40px', fontSize:'18px', color:'#666', textAlign:'center'}}>
                                The first 3 videos are free, no credit card required.
                            </p>
                            
                            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '15px', marginBottom: '20px' }}>
                                {/* Creator Plan */}
                                <div className="pricing-plan-card" style={{ 
                                    backgroundColor: 'white', 
                                    border: '1px solid #e0e0e0', 
                                    borderRadius: '8px', 
                                    padding: '20px',
                                    textAlign: 'center'
                                }}>
                                    <h5 style={{ marginTop: 0, marginBottom: '10px', color: 'black', paddingTop: '15px' }}>Creator</h5>
                                    <div style={{ fontSize: '24px', fontWeight: 'bold', marginBottom: '10px', color: 'black' }}>{currency}25/month</div>
                                    <ul style={{ textAlign: 'left', fontSize: '14px', color: '#555', margin: 0, paddingLeft: '15px', listStyleType: 'disc', lineHeight: '1.8' }}>
                                        <li>4 videos per month</li>
                                        <li>Import raw content</li>
                                        <li>Generate hooks, scripts, voiceovers</li>
                                        <li>Generate videos {/*<span style={{ color: '#ff6b6b' }}>(NO topic selection)</span></li>*/}</li>
                                        <li>50GB storage</li>
                                    </ul>
                                </div>
                                
                                {/* Pro Plan */}
                                <div className="pricing-plan-card" style={{ 
                                    backgroundColor: 'white', 
                                    border: '2px solid #AB5898', 
                                    borderRadius: '8px', 
                                    padding: '20px',
                                    textAlign: 'center',
                                    position: 'relative'
                                }}>
                                    <div style={{ 
                                        position: 'absolute', 
                                        top: '-12px', 
                                        left: '50%', 
                                        transform: 'translateX(-50%)', 
                                        backgroundColor: '#AB5898', 
                                        color: 'white', 
                                        padding: '4px 12px', 
                                        borderRadius: '4px', 
                                        fontSize: '12px',
                                        fontWeight: 'bold'
                                    }}>
                                        POPULAR
                                    </div>
                                    <h5 style={{ marginTop: '12px', marginBottom: '10px', color: 'black' }}>Pro</h5>
                                    <div style={{ fontSize: '24px', fontWeight: 'bold', marginBottom: '10px', color: 'black' }}>{currency}99/month</div>
                                    <ul style={{ textAlign: 'left', fontSize: '14px', color: '#555', margin: 0, paddingLeft: '15px', listStyleType: 'disc', lineHeight: '1.8' }}>
                                        <li>Unlimited videos generation</li>
                                        <li>Import raw content</li>
                                        <li>Generate hooks, scripts, voiceovers</li>
                                        <li>Generate videos {/*<span style={{ color: '#ff6b6b' }}>(WITH topic selection)</span></li>*/}</li>
                                        <li>200GB storage per profile</li>
                                        <li>+ Invite team members</li>
                                        <li>+ Multiple brand profiles (+{currency}99 per profile)</li>
                                    </ul>
                                    <p> Become an infinite content machine for {currency}99/month</p>
                                </div>
                        
                                {/* Premium Plan */}
                                <div className="pricing-plan-card" style={{ 
                                    backgroundColor: 'white', 
                                    border: '1px solid #e0e0e0', 
                                    borderRadius: '8px', 
                                    padding: '20px',
                                    textAlign: 'center'
                                }}>
                                    <h5 style={{ marginTop: 0, marginBottom: '10px', color: 'black', paddingTop: '15px' }}>Premium</h5>
                                    <div style={{ fontSize: '24px', fontWeight: 'bold', marginBottom: '10px', color: 'black' }}>{currency}255/month</div>
                                    <div style={{ fontSize: '14px', color: '#555', textAlign: 'left', lineHeight: '1.6' }}>
                                        <p style={{ margin: '0 0 8px 0' }}>
                                            Just upload your content, our team generates 8 videos per month for you. 
                                            You just need to download them and use them.
                                        </p>
                                    </div>
                                </div>
                        
                                {/* Custom Solution */}
                                {/* <div style={{ 
                                    backgroundColor: 'white', 
                                    border: '1px solid #e0e0e0', 
                                    borderRadius: '8px', 
                                    padding: '20px',
                                    textAlign: 'center'
                                }}>
                                    <h5 style={{ marginTop: 0, marginBottom: '10px', color: 'black' }}>Custom</h5>
                                    <div style={{ fontSize: '24px', fontWeight: 'bold', marginBottom: '10px', color: 'black' }}>Contact Us</div>
                                    <div style={{ fontSize: '14px', color: '#555', textAlign: 'center' }}>
                                        <p style={{ margin: '0 0 8px 0', lineHeight: '1.6' }}>
                                            Need more? Reach out for custom solution
                                        </p>
                                    </div>
                                </div> */}
                            </div>
                        </div>

                        {/* FAQ Section */}
                        <div style={{ color: 'black', textAlign: 'center', marginTop: '0px', padding: '20px', marginBottom:'40px', borderRadius: '8px', width:'80vw'}}>
                            <h2 className="gradient-text" style={{marginBottom:'40px', fontSize:'32px'}}>FAQ</h2>
                            
                            <div style={{textAlign:'left', maxWidth:'700px', margin:'0 auto', color:'black'}}>
                                {/* FAQ 1 */}
                                <div style={{marginBottom:'20px', border:'1px solid #e0e0e0', borderRadius:'8px', overflow:'hidden'}}>
                                    <button 
                                        onClick={() => setOpenFAQ(openFAQ === 1 ? null : 1)}
                                        style={{
                                            width:'100%',
                                            padding:'20px',
                                            backgroundColor:'white',
                                            border:'none',
                                            textAlign:'left',
                                            cursor:'pointer',
                                            fontSize:'16px',
                                            fontWeight:'bold',
                                            display:'flex',
                                            justifyContent:'space-between',
                                            alignItems:'center'
                                        }}
                                    >
                                        <span style={{color: 'black'}}>How does Merra.ai work?</span>
                                        <span>{openFAQ === 1 ? '−' : '+'}</span>
                                    </button>
                                    {openFAQ === 1 && (
                                        <div style={{padding:'20px', backgroundColor:'#f9f9f9', borderTop:'1px solid #e0e0e0'}}>
                                            <p style={{margin:0, color:'#555'}}>
                                                Simply upload your raw video content, and our AI automatically edits it for you. 
                                                No need for manual trimming, timeline editing, or technical skills. 
                                                You can regenerate as many times as you want until you're satisfied with the result.
                                            </p>
                                        </div>
                                    )}
                                </div>

                                {/* FAQ 2 */}
                                <div style={{marginBottom:'20px', border:'1px solid #e0e0e0', borderRadius:'8px', overflow:'hidden'}}>
                                    <button 
                                        onClick={() => setOpenFAQ(openFAQ === 2 ? null : 2)}
                                        style={{
                                            width:'100%',
                                            padding:'20px',
                                            backgroundColor:'white',
                                            border:'none',
                                            textAlign:'left',
                                            cursor:'pointer',
                                            fontSize:'16px',
                                            fontWeight:'bold',
                                            display:'flex',
                                            justifyContent:'space-between',
                                            alignItems:'center'
                                        }}
                                    >
                                        <span style={{color: 'black'}}>What types of videos can I create?</span>
                                        <span>{openFAQ === 2 ? '−' : '+'}</span>
                                    </button>
                                    {openFAQ === 2 && (
                                        <div style={{padding:'20px', backgroundColor:'#f9f9f9', borderTop:'1px solid #e0e0e0'}}>
                                            <p style={{margin:0, color:'#555'}}>
                                                Merra.ai is perfect for short form social media content, and best for storytelling / voiceover content.
                                                Our goal is to create a script that is engaging and interesting to watch, then we edit the video with filler content.
                                                If you need content to exactly match the voiceover, for example a product demo, Merra won't be the best fit.
                                            </p>
                                        </div>
                                    )}
                                </div>

                                {/* FAQ 3 */}
                                <div style={{marginBottom:'20px', border:'1px solid #e0e0e0', borderRadius:'8px', overflow:'hidden'}}>
                                    <button 
                                        onClick={() => setOpenFAQ(openFAQ === 3 ? null : 3)}
                                        style={{
                                            width:'100%',
                                            padding:'20px',
                                            backgroundColor:'white',
                                            border:'none',
                                            textAlign:'left',
                                            cursor:'pointer',
                                            fontSize:'16px',
                                            fontWeight:'bold',
                                            display:'flex',
                                            justifyContent:'space-between',
                                            alignItems:'center'
                                        }}
                                    >
                                        <span style={{color: 'black'}}>Do I need video editing experience?</span>
                                        <span>{openFAQ === 3 ? '−' : '+'}</span>
                                    </button>
                                    {openFAQ === 3 && (
                                        <div style={{padding:'20px', backgroundColor:'#f9f9f9', borderTop:'1px solid #e0e0e0'}}>
                                            <p style={{margin:0, color:'#555'}}>
                                                Not at all! Merra.ai is designed for people who don't have time to edit videos 
                                                or don't have video editing skills. Our AI does all the heavy lifting, you just 
                                                upload and click 'regenerate' until you're happy.
                                            </p>
                                        </div>
                                    )}
                                </div>

                                {/* FAQ 4 */}
                                <div style={{marginBottom:'20px', border:'1px solid #e0e0e0', borderRadius:'8px', overflow:'hidden'}}>
                                    <button 
                                        onClick={() => setOpenFAQ(openFAQ === 4 ? null : 4)}
                                        style={{
                                            width:'100%',
                                            padding:'20px',
                                            backgroundColor:'white',
                                            border:'none',
                                            textAlign:'left',
                                            cursor:'pointer',
                                            fontSize:'16px',
                                            fontWeight:'bold',
                                            display:'flex',
                                            justifyContent:'space-between',
                                            alignItems:'center'
                                        }}
                                    >
                                        <span style={{color: 'black'}}>What if I'm not satisfied with the results?</span>
                                        <span>{openFAQ === 4 ? '−' : '+'}</span>
                                    </button>
                                    {openFAQ === 4 && (
                                        <div style={{padding:'20px', backgroundColor:'#f9f9f9', borderTop:'1px solid #e0e0e0'}}>
                                            <p style={{margin:0, color:'#555'}}>
                                                You can regenerate unlimited times at no extra cost. Our AI learns your preferences 
                                                and each version gets better.
                                            </p>
                                        </div>
                                    )}
                                </div>

                                {/* FAQ 5 */}
                                <div style={{marginBottom:'20px', border:'1px solid #e0e0e0', borderRadius:'8px', overflow:'hidden'}}>
                                    <button 
                                        onClick={() => setOpenFAQ(openFAQ === 5 ? null : 5)}
                                        style={{
                                            width:'100%',
                                            padding:'20px',
                                            backgroundColor:'white',
                                            border:'none',
                                            textAlign:'left',
                                            cursor:'pointer',
                                            fontSize:'16px',
                                            fontWeight:'bold',
                                            display:'flex',
                                            justifyContent:'space-between',
                                            alignItems:'center'
                                        }}
                                    >
                                        <span style={{color: 'black'}}>Is my video content secure?</span>
                                        <span>{openFAQ === 5 ? '−' : '+'}</span>
                                    </button>
                                    {openFAQ === 5 && (
                                        <div style={{padding:'20px', backgroundColor:'#f9f9f9', borderTop:'1px solid #e0e0e0'}}>
                                            <p style={{margin:0, color:'#555'}}>
                                                Absolutely. We take data security seriously. Your content is encrypted, stored securely, 
                                                and never shared with third parties. You can delete your content at any time.
                                            </p>
                                        </div>
                                    )}
                                </div>

                                {/* FAQ 6 */}
                                <div style={{marginBottom:'20px', border:'1px solid #e0e0e0', borderRadius:'8px', overflow:'hidden'}}>
                                    <button 
                                        onClick={() => setOpenFAQ(openFAQ === 6 ? null : 6)}
                                        style={{
                                            width:'100%',
                                            padding:'20px',
                                            backgroundColor:'white',
                                            border:'none',
                                            textAlign:'left',
                                            cursor:'pointer',
                                            fontSize:'16px',
                                            fontWeight:'bold',
                                            display:'flex',
                                            justifyContent:'space-between',
                                            alignItems:'center'
                                        }}
                                    >
                                        <span style={{color: 'black'}}>Will it look AI-generated?</span>
                                        <span>{openFAQ === 6 ? '−' : '+'}</span>
                                    </button>
                                    {openFAQ === 6 && (
                                        <div style={{padding:'20px', backgroundColor:'#f9f9f9', borderTop:'1px solid #e0e0e0'}}>
                                            <p style={{margin:0, color:'#555'}}>
                                                No! Merra.ai uses your own video content, so the final result looks completely authentic. 
                                                Our AI simply edits and enhances YOUR video, it doesn't generate artificial content. 
                                                You provide the footage, we provide the polish. The end result is professional-quality video 
                                                that showcases your brand authentically.
                                            </p>
                                        </div>
                                    )}
                                </div>

                                {/* FAQ 7 */}
                                <div style={{marginBottom:'20px', border:'1px solid #e0e0e0', borderRadius:'8px', overflow:'hidden'}}>
                                    <button 
                                        onClick={() => setOpenFAQ(openFAQ === 7 ? null : 7)}
                                        style={{
                                            width:'100%',
                                            padding:'20px',
                                            backgroundColor:'white',
                                            border:'none',
                                            textAlign:'left',
                                            cursor:'pointer',
                                            fontSize:'16px',
                                            fontWeight:'bold',
                                            display:'flex',
                                            justifyContent:'space-between',
                                            alignItems:'center'
                                        }}
                                    >
                                        <span style={{color: 'black'}}>Can I sign up for free?</span>
                                        <span>{openFAQ === 7 ? '−' : '+'}</span>
                                    </button>
                                    {openFAQ === 7 && (
                                        <div style={{padding:'20px', backgroundColor:'#f9f9f9', borderTop:'1px solid #e0e0e0'}}>
                                            <p style={{margin:0, color:'#555'}}>
                                                Yes! Sign up is completely free with no credit card required. You can generate 2 videos, then you can upgrade to a paid plan. We offer flexible pricing plans 
                                                based on your needs. Check out the pricing section for more details. You can cancel at any time. Start your free trial today and see the difference Merra.ai can make 
                                                for your content creation.
                                            </p>
                                        </div>
                                    )}
                                </div>

                                {/* FAQ 8 */}
                                <div style={{marginBottom:'20px', border:'1px solid #e0e0e0', borderRadius:'8px', overflow:'hidden'}}>
                                    <button 
                                        onClick={() => setOpenFAQ(openFAQ === 8 ? null : 8)}
                                        style={{
                                            width:'100%',
                                            padding:'20px',
                                            backgroundColor:'white',
                                            border:'none',
                                            textAlign:'left',
                                            cursor:'pointer',
                                            fontSize:'16px',
                                            fontWeight:'bold',
                                            display:'flex',
                                            justifyContent:'space-between',
                                            alignItems:'center'
                                        }}
                                    >
                                        <span style={{color: 'black'}}>How long does it take to create a video?</span>
                                        <span>{openFAQ === 8 ? '−' : '+'}</span>
                                    </button>
                                    {openFAQ === 8 && (
                                        <div style={{padding:'20px', backgroundColor:'#f9f9f9', borderTop:'1px solid #e0e0e0'}}>
                                            <p style={{margin:0, color:'#555'}}>
                                                It usuallytakes 2 minutes to create a video.
                                            </p>
                                        </div>
                                    )}
                                </div>

                                {/* FAQ 9 */}
                                <div style={{marginBottom:'20px', border:'1px solid #e0e0e0', borderRadius:'8px', overflow:'hidden'}}>
                                    <button 
                                        onClick={() => setOpenFAQ(openFAQ === 9 ? null : 9)}
                                        style={{
                                            width:'100%',
                                            padding:'20px',
                                            backgroundColor:'white',
                                            border:'none',
                                            textAlign:'left',
                                            cursor:'pointer',
                                            fontSize:'16px',
                                            fontWeight:'bold',
                                            display:'flex',
                                            justifyContent:'space-between',
                                            alignItems:'center'
                                        }}
                                    >
                                        <span style={{color: 'black'}}>Isn't it a bit expensive?</span>
                                        <span>{openFAQ === 9 ? '−' : '+'}</span>
                                    </button>
                                    {openFAQ === 9 && (
                                        <div style={{padding:'20px', backgroundColor:'var(--background-tertiary)', borderTop:'1px solid var(--border-primary)'}}>
                                            <p style={{margin:0, color:'var(--text-secondary)'}}>
                                                It’s a lot, because we want you to post a lot of videos. Paying more gives you an extra incentive to post more videos. If you only paid {currency}10 a month, you would be fine posting 1 video and you wouldn't have any result.
                                                <br/>
                                                It's also much faster than any other cheaper tool (you save a ton of time if you usually edit your own videos, and this is valuable), and way cheaper than hiring a freelancer.
                                            </p>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>

                        {/*                         
                        <section>
                            <p>Glide To Reveal Secret Code</p>
                            <ul class="code">
                                <li tabindex="0" class="digit">
                                <span>0</span>
                                </li>
                                <li tabindex="0" class="digit">
                                <span>3</span>
                                </li>
                                <li tabindex="0" class="digit">
                                <span>4</span>
                                </li>
                                <li tabindex="0" class="digit">
                                <span>8</span>
                                </li>
                                <li tabindex="0" class="digit">
                                <span>7</span>
                                </li>
                                <li tabindex="0" class="digit">
                                <span>2</span>
                                </li>
                            </ul>
                        </section>
                         */}
                        {/* <div style={{marginBottom:'50px', marginTop:'100px'}}>
                            <span style={{fontWeight:'bold', color: 'black'}}>If you're not ready to sign up yet, follow us on social media</span>
                            <div class="social-media-wrapper" style={{marginTop:'10px'}}>
                                <a href="https://x.com/merra_ai" target="_blank" rel="noopener noreferrer">
                                    <img src="https://pngimg.com/uploads/x_logo/x_logo_PNG18.png" alt="X" style={{width:'40px', height:'40px'}} />
                                </a>
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>

            {/* Demo Modal */}
            {showDemoModal && (
                <div 
                    onClick={() => setShowDemoModal(false)}
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(0, 0, 0, 0.8)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 10000
                    }}
                >
                    <div 
                        onClick={(e) => e.stopPropagation()}
                        style={{
                            position: 'relative',
                            maxWidth: '90vw',
                            maxHeight: '90vh',
                            backgroundColor: 'white',
                            borderRadius: '12px',
                            padding: '20px',
                            boxShadow: '0 10px 40px rgba(0,0,0,0.3)'
                        }}
                    >
                        <button
                            onClick={() => setShowDemoModal(false)}
                            style={{
                                position: 'absolute',
                                top: '10px',
                                right: '10px',
                                backgroundColor: 'transparent',
                                border: 'none',
                                fontSize: '30px',
                                color: '#666',
                                cursor: 'pointer',
                                width: '40px',
                                height: '40px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                borderRadius: '50%',
                                transition: 'background-color 0.2s ease'
                            }}
                            onMouseOver={(e) => e.target.style.backgroundColor = '#f0f0f0'}
                            onMouseOut={(e) => e.target.style.backgroundColor = 'transparent'}
                        >
                            ×
                        </button>
                        <video
                            src="https://proto-filesharing.s3.eu-north-1.amazonaws.com/public/Demo+Fast+Video+Creation.mp4"
                            controls
                            autoPlay
                            style={{
                                maxWidth: '80vw',
                                maxHeight: '80vh',
                                borderRadius: '8px'
                            }}
                            playsInline
                        >
                            <source src="https://proto-filesharing.s3.eu-north-1.amazonaws.com/public/Demo+Fast+Video+Creation.mp4" type="video/mp4" />
                            Your browser does not support the video tag.
                        </video>
                    </div>
                </div>
            )}

            {/* Waitlist Modal */}
            {showWaitlistModal && (
                <div
                    onClick={() => setShowWaitlistModal(false)}
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(0, 0, 0, 0.7)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 10000
                    }}
                >
                    <div
                        onClick={(e) => e.stopPropagation()}
                        style={{
                            backgroundColor: '#ffffff',
                            padding: '40px',
                            borderRadius: '12px',
                            boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
                            maxWidth: '500px',
                            width: '90%',
                            maxHeight: '90vh',
                            overflow: 'auto'
                        }}
                    >
        
                        <div style={{ marginBottom: '30px', textAlign: 'center' }}>

                            <button
                                onClick={() => setShowWaitlistModal(false)}
                                style={{
                                    background: 'none',
                                    border: 'none',
                                    fontSize: '24px',
                                    cursor: 'pointer',
                                    color: '#666',
                                    width: '40px',
                                    height: '40px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifySelf: 'flex-end',
                                    justifyContent: 'center',
                                    borderRadius: '50%',
                                    transition: 'background-color 0.2s ease'
                                }}
                                onMouseOver={(e) => e.target.style.backgroundColor = '#f0f0f0'}
                                onMouseOut={(e) => e.target.style.backgroundColor = 'transparent'}
                            >
                                ×
                            </button>
                            <h2 className='gradient-text' style={{ color: 'black', marginBottom: '10px', fontSize:'28px' }}>
                                Get early access to Merra.ai
                            </h2>
                        </div>
                        <div className="field-wrapper" style={{ marginTop: '20px' }}>
                            <input
                                value={waitlistEmail}
                                onChange={(e) => setWaitlistEmail(e.target.value)}
                                autoComplete="off"
                                name="email"
                                className="field"
                                maxLength="256"
                                placeholder="Your email"
                                type="email"
                                id="mail"
                                required
                                style={{
                                    fontSize: '16px',
                                    color: 'black',
                                    backgroundColor: '#FFFFFF',
                                    borderRadius: '8px',
                                    padding: '12px 15px',
                                    border: '1px solid #ccc',
                                    width: '100%',
                                    boxSizing: 'border-box',
                                    marginBottom: '15px'
                                }}
                            />
                            <button
                                onClick={handleWaitlistSignup}
                                className='waitlist-button'
                                style={{
                                    margin: '10px 0',
                                    borderWidth: '0px',
                                    width: '100%'
                                }}
                            >
                                <span style={{ color: 'black' }}>Join waitlist</span>
                                <span className="waitlist-shimmer"></span>
                            </button>
                            {waitlistMessage && (
                                <p style={{
                                    marginTop: '15px',
                                    color: waitlistMessage.includes('Thank you') ? 'green' : 'red',
                                    textAlign: 'center',
                                    fontSize: '14px'
                                }}>
                                    {waitlistMessage}
                                </p>
                            )}
                        </div>
                    </div>
                </div>
            )}
            <Footer />
        </div>
    );
}

export default LandingPage;